<template>
  <main>
    <tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h4 class="text-green">
                        轄下未訪/準未訪件資訊
                    </h4>
                    <form class="form">
                        <div class="form-group row">
                            <label class="col-1 text-right">服務人員</label>
                            <div class="col-11">
                                <select class="form-control form-control-inline form-wide ml-0" v-model="selectedAg" alt="ch">
                                  <option value=''>請選擇</option>
                                  <option
                                    v-for="(ag, agOptIndex) in agOpt"
                                    :key="`service-ag-${agOptIndex}`"
                                    :value="ag">{{ag.div_no}} {{ag.ceempnm}}</option>
                                </select>
                                <a @click="searchData()" class="btn btn-primary mt-0">查詢</a>&nbsp;&nbsp;
                                <div class="radio radio-inline" >
                                  <input type="radio" v-model="searchType" id="search-type-1" value="1" />
                                  <label for="search-type-1">轄下未訪件資訊</label>
                                </div>
                                <div class="radio radio-inline">
                                  <input type="radio" v-model="searchType" id="search-type-2" value="2" />
                                  <label for="search-type-2">轄下準未訪件資訊</label>
                                </div>
                            </div>
                        </div>
                        <div>
                          <span v-if="searchType=='1'">
                            ＊{{ idfin_count1 }}要保人，{{ plfin_count1 }}張保單
                          </span>
                          <span v-if="searchType=='2'">
                            ＊{{ idfin_count2 }}要保人，{{ plfin_count2 }}張保單
                          </span>
                        </div>
                        <br>
                    </form>
                </div>
                <div class="col-12" :class="{'section-loading': isDataTreeLoading}">
                    <table class="table datatable insurance-green">
                        <thead>
                            <tr>
                                <th width="40">#</th>
                                <th width="100" class="sorting"
                                @click="columnSorting(1)"
                                :class="order.index==1 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''">
                                    經手人<br/>(第一)
                                </th>
                                <th width="100" class="sorting"
                                @click="columnSorting(2)"
                                :class="order.index==2 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''">
                                    客戶<br/>姓名
                                </th>
                                <th width="*" class="sorting"
                                @click="columnSorting(3)"
                                :class="order.index==3 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''">
                                    客戶標記
                                </th>
                                <th width="120" class="sorting"
                                @click="columnSorting(4)"
                                :class="order.index==4 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''">
                                    保單號碼
                                </th>
                                <th width="100" class="sorting"
                                @click="columnSorting(5)"
                                :class="order.index==5 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''">
                                    收費代號
                                </th>
                                <th width="100" class="sorting"
                                @click="columnSorting(6)"
                                :class="order.index==6 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''">
                                    下次<br/>應繳日
                                </th>
                                <th width="70" class="sorting"
                                @click="columnSorting(7)"
                                :class="order.index==7 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''">
                                    繳費<br/>管道
                                </th>
                                <th width="110" class="sorting"
                                @click="columnSorting(8)"
                                :class="order.index==8 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''">
                                    契約<br/>效力
                                </th>
                                <th width="110" class="sorting"
                                @click="columnSorting(9)"
                                :class="order.index==9 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''">
                                    投保日
                                </th>
                                <th width="70">
                                    保戶<br/>通聯
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="dataTree.length">
                          <tr v-for="(row, rid) in dataTree" :key="`row-${rid}-${row.ceplcno}`">
                            <td>{{rid + 1}}</td>
                            <td>{{row.ceagnnm}}</td>
                            <td>{{row.ceapcnm}}</td>
                            <td v-if="searchType == '1'">
                              <span v-for="(t, idx) in (row.taglist || [])" :key="idx">
                                <span :style="{ color: t.color }">{{ t.tag }}</span>
                                <span v-if="row.taglist && idx !== row.taglist.length - 1">、</span>
                              </span>
                              <span v-if="$options.filters.IDmarkFormat(row.idmark) !== '' && row.taglist && row.taglist.length !== 0">、</span>
                              <span>{{ row.idmark | IDmarkFormat }}</span>
                            </td>
                            <td v-else>
                              <span v-if="!row.idmark || row.idmark.trim() == '' || row.idmark == '0'"></span>
                              <span v-else>{{ row.idmark | IDmarkFormat }}</span>
                            </td>
                            <td>{{row.ceplcno}}</td>
                            <td>{{row.ceclcno}}</td>
                            <td>{{row.cenxpdt | dateToROCdateFormat}}</td>
                            <td>{{row.pay_type | payTypeFormat}}</td>
                            <td>{{row.celpscs_nm}}</td>
                            <td>{{row.ceplcdt | dateToROCdateFormat}}</td>
                            <td>
                                <a class="link text-underline" @click="searchContact(row)">查詢</a>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="11">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <!-- <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="11">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody> -->
                    </table>
                    <div>
                        <ol>
                            <!-- <li>未訪件於106年度引起列為強制撥出，每年1-9月為預警期，10-12月為強制撥出期<br/>部保費企劃科，(02)27551399#1916</li> -->
                            <li>如有其他疑問，請洽總公司業務部業務企劃科，(02)27551399#{{ contactInfo.contact_tel }}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>

    <connect-data-modal
    :open="connectModalOpen"
    :loading="isPolicyContactInfoLoading"
    :detailData="policyContactInfo"
    @close="panelClose('connectModalOpen')"
    />
  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import TabHeader from '@/desktop/components/manager/TabHeader'
import ConnectDataModal from '@/desktop/components/manager/ConnectData'
import { debuglog } from 'util';
import { queryBelowEstrangeAg, queryBelowEstrangePolicy, queryBelowEstrangePolicyContactInfo, getContactInfoBySerNo } from '../../../service'

export default {
  name: 'TransferTab62',
  mixins: [commonMixin],
  components: {
    TabHeader, ConnectDataModal
  },
  computed: {
  },
  data () {
    return {
      clcno_lv: '',
      connectModalOpen: false,
      order: {
          index: 2,
          asc: true
      },
      dataTree: [],
      isDataTreeLoading: false,
      selectedAg: '',
      agOpt: [],
      policyContactInfo: {},
      isPolicyContactInfoLoading: false,
      searchType:"1",
      estrange_policy_list: [], //未訪件明細
      the_estrange_policy_list: [], //準未訪件明細
      idfin_count1:"0",
      idfin_count2:"0",
      plfin_count1:"0",
      plfin_count2:"0",
      contactInfo: []
    }
  },
  watch: {
    searchType: function(val) {
      if (val == "1") {
        this.dataTree = [...this.estrange_policy_list];
      } else {
        this.dataTree = [...this.the_estrange_policy_list];
      }
      this.registerHanlink();
    }    
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    searchData () {
      this.isDataTreeLoading = true
      if(typeof this.selectedAg === 'object') {
        queryBelowEstrangePolicy(this.$store.state.userInfo.id, this.selectedAg.agidno).then(result => {
          if(result.header && result.header.status == '200') {
            this.estrange_policy_list = result.body.estrange_policy;
            this.the_estrange_policy_list = result.body.the_estrange_policy;
            result.body.total_list.map(item => {
              this.idfin_count1 = item.idfin_count1 ? item.idfin_count1 : "0";
              this.idfin_count2 = item.idfin_count2 ? item.idfin_count2 : "0";
              this.plfin_count1 = item.plfin_count1 ? item.plfin_count1 : "0";
              this.plfin_count2 = item.plfin_count2 ? item.plfin_count2 : "0";
            });
            if (this.searchType == "1") {
              this.dataTree = [...this.estrange_policy_list];
            } else {
              this.dataTree = [...this.the_estrange_policy_list];
            }
            this.dataTree.sort(this.sortCompareFun('ceapcnm'))
          } else {
            this.dataTree = []
            if(result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '清單查詢失敗,請重新操作'})
            }
          }
          this.isDataTreeLoading = false
          this.registerHanlink()
        })
      } else {
        this.$toast.info({title: '請選擇服務人員'})
        this.isDataTreeLoading = false
      }
    },
    searchContact (target) {
      this.isPolicyContactInfoLoading = true
      queryBelowEstrangePolicyContactInfo(this.$store.state.userInfo.id, target.ceapcno, target.ceapcnm).then(result => {
        if(result.header && result.header.status == '200') {
          this.policyContactInfo = result.body.detail
        } else {
          this.policyContactInfo = {}
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '保戶通聯資料查詢失敗,請重新操作'})
          }
        }
        this.isPolicyContactInfoLoading = false
        this.registerHanlink()
      })
      this.panelOpen('connectModalOpen')
    },
    columnSorting(i) {
      //切換表頭圖案
      if (this.order.index == i) {
          this.order.asc = !this.order.asc
      } else {
          this.order.asc = true
      }
      this.order.index = i

      //data排序
      switch(i) {
        case 1:
          this.dataTree.sort(this.sortCompareFun('ceagnnm'))
          break;
        case 2:
          this.dataTree.sort(this.sortCompareFun('ceapcnm'))
          break;
        case 3:
          this.dataTree.sort(this.sortCompareFun('idmark'))
          break;
        case 4:
          this.dataTree.sort(this.sortCompareFun('ceplcno'))
          break;
        case 5:
          this.dataTree.sort(this.sortCompareFun('ceclcno'))
          break;
        case 6:
          this.dataTree.sort(this.sortCompareFun('cenxpdt'))
          break;
        case 7:
          this.dataTree.sort(this.sortCompareFun('pay_type'))
          break;
        case 8:
          this.dataTree.sort(this.sortCompareFun('celpscs_nm'))
          break;
        case 9:
          this.dataTree.sort(this.sortCompareFun('ceplcdt'))
          break;
        default:
          break;
      }
      // for 難字 update
      let cacheList = [...this.dataTree]
      this.dataTree = []
      setTimeout(() => {
        this.dataTree = cacheList
        this.registerHanlink()
      }, 200)
    },
    sortCompareFun(property) {
      let sortOrder = 1
      if(!this.order.asc) {
        sortOrder = -1
      }
      return function(a, b) {
        let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
      }
    },
    initTransferTab62() {
      this.initClcno()
      queryBelowEstrangeAg(this.$store.state.userInfo.id, this.clcno_lv).then(result => {
        if(result.header && result.header.status == '200') {
          this.agOpt = result.body.estrange_agent
        } else {
          if(result.header && result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '初始化失敗,請重新操作'})
          }
        }
        this.registerHanlink()
      })
    },
    initContactInfo(){
      // 以流水編號查詢企劃單位連絡方式
      getContactInfoBySerNo(this.$store.state.userInfo.id, '11').then(result => {
        if(result && result.header.status == '200' && result.body){
            this.contactInfo  = result.body.lists[0];
        }
      })
    },
    initClcno() {
      let clcno = this.$store.state.userInfo.divNo
      if(this.$store.state.userInfo.divNo.substr(2, 1) == '4') {
        clcno = this.$store.state.userInfo.divNo.substr(0,2) + '5' + this.$store.state.userInfo.divNo.substr(3,5)
      }
      switch(this.$store.state.userInfo.roleId) {
        case 'SALES_MANAGER_02':
        case 'SALES_MANAGER_05':
          this.clcno_lv = clcno.substr(0, 3)
          break;
        case 'SALES_MANAGER_06':
           if(this.$store.state.userInfo.userCategoryId =='A019'){
            this.clcno_lv = clcno.substr(0, 3)
            break;
          }else if(this.$store.state.userInfo.userCategoryId =='A044'){
            this.clcno_lv = clcno.substr(0, 4)
            break;
          }
          else{
            this.clcno_lv = clcno.substr(0, 5)
            break;
          }
        case 'SALES_MANAGER_03':
          this.clcno_lv = clcno.substr(0, 4)
          break;
        case 'SALES_MANAGER_04':
          this.clcno_lv = clcno.substr(0, 5)
          break;
      }
    }
  },
  beforeMount () {
    this.initTransferTab62()
  },
  mounted () {
    //獲得企劃單位聯絡資訊
    this.initContactInfo()
  }
}
</script>
